// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"42":"e59f9119","185":"34fb698e","559":"815b6a1c","769":"4c6e0844"}[chunkId] + ".chunk.js";
};